import {
    PersonIcon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useCallback, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

function ChangeFarmBreederDialog({ farm, fetchFarmInformation }) {

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);

        try {
            await api.post(`https://skhrf-api.cmdigital.se/v1/farms/update-breeder`, {
                farmId: farm.id,
                breederEmail: email,
            });
            fetchFarmInformation();
            toast({
                title: 'Ägare bytt',
                description: `${farm.name}s ägare blev bytt till användare med e-post ${email}.`,
            });
            setIsDialogOpen(false);
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleValueChange = useCallback((e) => {
        setEmail(e.target.value);
    }, []);

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <PersonIcon className='mr-3' />Ändra ägare
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Ändra gårdsägare</DialogTitle>
                    <DialogDescription>Ange en användares e-postadress för att byta ägarskap på {farm.name}</DialogDescription>
                </DialogHeader>
                <Input
                    id='email'
                    type='text'
                    placeholder='hej@cmdigital.se'
                    value={email}
                    onChange={handleValueChange}
                />
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Ändra ägare</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeFarmBreederDialog;
